import { useEffect } from 'react'

export default function ContactSupportPopup({ open, onClose }) {
  useEffect(() => {
    if (!open) return
    const handler = (e) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-6"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[440px] rounded-[16px] bg-white p-8 shadow-lg relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 w-8 h-8 flex items-center justify-center text-brand-dark hover:text-brand-green"
          aria-label="Close"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <h2 className="text-[24px] font-extrabold text-brand-dark">Questions?</h2>
        <p className="mt-3 text-[15px] leading-[24px] text-brand-dark/85">
          Email us at{' '}
          <a href="mailto:support@reilm.io" className="text-brand-green font-semibold">
            support@reilm.io
          </a>
          , and our team will get back to you as soon as possible.
        </p>
        <p className="mt-4 text-[13px] text-brand-dark/60">Monday–Friday, 9AM–5PM EST</p>
      </div>
    </div>
  )
}
